import React from "react";
import { motion } from "framer-motion";
import "./style.css";

const ProjectCard = ({
  title,
  description,
  image,
  category,
  index,
  url,
}) => {
  const isExternal = url?.startsWith("http");

  return (
    <motion.a
      href={url}
      target={isExternal ? "_blank" : "_self"}
      rel={isExternal ? "noopener noreferrer" : undefined}
      initial={{ opacity: 0, y: 60 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{
        duration: 0.7,
        delay: index * 0.1,
        ease: [0.25, 0.46, 0.45, 0.94],
      }}
      className="project-card"
    >
      <div className="image-container">
        <motion.img
          src={image}
          alt={title}
          whileHover={{ scale: 1.08 }}
          transition={{
            duration: 0.6,
            ease: [0.25, 0.46, 0.45, 0.94],
          }}
        />

        <div className="overlay" />

        <div className="arrow-icon"></div>

        <div className="category-badge">
          {category}
        </div>
      </div>

      <div className="text-content">
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
    </motion.a>
  );
};

export default ProjectCard;